
import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '@/components/Layout';
import { Link } from 'react-router-dom';
import { financialCategory } from '@/lib/data/categories/financial';
import { healthCategory } from '@/lib/data/categories/health';
import { educationCategory } from '@/lib/data/categories/education';
import { lifestyleCategory } from '@/lib/data/categories/lifestyle';
import { professionalCategory } from '@/lib/data/categories/professional';

const Sitemap: React.FC = () => {
  const categories = [
    {
      name: 'Financial Tools',
      path: '/calculators/financial-tools',
      calculators: financialCategory.calculators,
      categorySlug: 'financial-tools'
    },
    {
      name: 'Health & Wellness',
      path: '/calculators/health-wellness',
      calculators: healthCategory.calculators,
      categorySlug: 'health-wellness'
    },
    {
      name: 'Math & Education',
      path: '/calculators/education',
      calculators: educationCategory.calculators,
      categorySlug: 'education'
    },
    {
      name: 'Lifestyle & Fun',
      path: '/calculators/lifestyle',
      calculators: lifestyleCategory.calculators,
      categorySlug: 'lifestyle'
    },
    {
      name: 'Professional Tools',
      path: '/calculators/professional-tools',
      calculators: professionalCategory.calculators,
      categorySlug: 'professional-tools'
    }
  ];

  return (
    <Layout>
      <Helmet>
        <title>Sitemap | GetCalculator</title>
        <meta 
          name="description" 
          content="Complete sitemap of GetCalculator. Find all our calculator tools organized by category including financial, health, education, lifestyle, and professional calculators."
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://getcalculator.net/sitemap" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-8">Sitemap</h1>
        
        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-4">Main Pages</h2>
            <ul className="space-y-2 ml-4">
              <li>
                <Link to="/" className="text-blue-600 dark:text-blue-400 hover:underline">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-blue-600 dark:text-blue-400 hover:underline">About</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-blue-600 dark:text-blue-400 hover:underline">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-blue-600 dark:text-blue-400 hover:underline">Terms of Use</Link>
              </li>
              <li>
                <Link to="/sitemap" className="text-blue-600 dark:text-blue-400 hover:underline">Sitemap</Link>
              </li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">Calculator Categories</h2>
            <ul className="space-y-2 ml-4">
              {categories.map(category => (
                <li key={category.path}>
                  <Link 
                    to={category.path} 
                    className="text-blue-600 dark:text-blue-400 hover:underline"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
          
          {categories.map(category => (
            <section key={category.path}>
              <h2 className="text-xl font-semibold mb-4">{category.name} Calculators</h2>
              <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 ml-4">
                {category.calculators.map(calculator => (
                  <li key={calculator.id}>
                    <Link 
                      to={`/calculators/${category.categorySlug}/${calculator.id}`} 
                      className="text-blue-600 dark:text-blue-400 hover:underline"
                    >
                      {calculator.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Sitemap;
